var exports = {
  "k": "xb99ab02a--6456a4--container",
};

module.exports = exports;
